/**
 * @file index.tsx
 * @author markJia(markjia@tencent.com)
 */
import { Modal as ModalComponent } from './Modal';
import { withModalFn } from './FnModal';
var Modal = ModalComponent;
Modal.alert = withModalFn({
  type: 'alert'
});
Modal.confirm = withModalFn({
  type: 'confirm'
});
export { Modal, withModalFn };